import React from 'react'
import { BarChart, Label, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer, Cell } from "recharts";
import { getTextWidth } from "get-text-width";
const barchartWidth = "100%";

class BarChartwRefLine extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            chartData: props.chartData || [],
            barDataKey: props.barDataKey,
            lineValue: Number(props.total) || 0, // Ensure it's a number
            height: 450,
            YAxisWidth: 150,
            displayChart: false,
            showErrorModal: false,
            errorMessage: ''
        }

        this.initializeState = this.initializeState.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
    }

    initializeState() {
        const chartData = this.props.chartData || [];
        
        if (chartData.length === 0) {
            this.setState({ displayChart: false });
            return;
        }

        var lenBarData = chartData.length;
        var heightAux = lenBarData * 40 + 5 * (lenBarData - 2);
        if (heightAux < 300) {
            heightAux = 300;
        }

        var YAxisWidthAux = 150;
        try {
            // Ensure we are getting the length of a string, even if name is null
            YAxisWidthAux = Math.max(...chartData.map(l => getTextWidth(String(l.name || ""))));
        } catch(e) {
            console.error("ERRO [BarChartwRefLine]: Falha ao calcular a largura do texto do eixo Y.", e);
            this.setState({ 
                showErrorModal: true, 
                errorMessage: "Não foi possível processar a formatação visual deste gráfico. Por favor, contate o serviço técnico da DATA E." 
            });
        }

        // Ensure lineValue is a valid number
        const safeLineValue = Number(this.props.total);

        this.setState({ 
            height: heightAux,
            YAxisWidth: YAxisWidthAux + 5,
            chartData: chartData,
            barDataKey: this.props.barDataKey,
            lineValue: isNaN(safeLineValue) ? 0 : safeLineValue, // Protect against NaN
            displayChart: true 
        });
    };

    componentDidUpdate = async (prevProps) => {
        // Only re-initialize if the data or the total line actually changed
        if (this.props.chartData !== prevProps.chartData || this.props.total !== prevProps.total) {
            this.initializeState();
        }
    }

    componentDidMount = async () => {
        this.initializeState();
    }
    
    render() {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <br />
                {this.state.displayChart &&
                    <ResponsiveContainer width={barchartWidth} height={this.state.height}>
                        <BarChart width={barchartWidth} height={this.state.height} data={this.state.chartData}
                            layout="vertical" margin={{ top: 30, right: 30, left: 0, bottom: 5 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            {/* Force domain to avoid auto-scaling errors if data is flat */}
                            <XAxis type="number" tick={{ fontSize: 14 }} domain={[0, 'auto']} allowDataOverflow={false} />
                            <YAxis width={this.state.YAxisWidth} tick={{ fontSize: 14 }}
                                tickLine={true}
                                tickMargin={5} type="category" dataKey="name" interval={0} />
                            <Tooltip wrapperStyle={{fontSize: "16px"}} cursor={{fill:"#CACACA"}}/>
                            <Bar dataKey={this.state.barDataKey}>
                                {this.state.chartData.map((datum, index) => (
                                    <Cell
                                        key={`cell-refline-${index}`}
                                        fill={
                                            (Number(datum[this.state.barDataKey]) || 0) > 0
                                                ? '#7D93CA'
                                                : '#4D65A4'
                                        }
                                    />
                                ))}
                            </Bar>
                            
                            <ReferenceLine x={this.state.lineValue}
                                isFront={true}
                                strokeDasharray="6 6"
                                stroke="#afbbca"
                                strokeWidth={3}>
                                <Label style={{fontSize: "16px"}} value={" " + this.state.lineValue} position={"top"} />
                            </ReferenceLine>
                        </BarChart>
                    </ResponsiveContainer>
                }
                {/* --- MODAL DE ERRO / AVISO (PARA UTILIZADORES FINAIS) --- */}
                {this.state.showErrorModal && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center',
                        alignItems: 'center', zIndex: 3000
                    }}>
                        <div style={{
                            backgroundColor: '#fff', width: '90%', maxWidth: '400px',
                            borderRadius: '5px', padding: '20px', textAlign: 'center',
                            boxShadow: '0 0 20px rgba(0,0,0,0.5)', fontFamily: 'sans-serif'
                        }}>
                            <div style={{ color: '#dc3545', fontSize: '16px' }}>
                                <p style={{ fontSize: '40px', margin: '0 0 10px 0' }}>❌</p>
                                <strong style={{ color: '#333' }}>Erro na Apresentação</strong>
                                <p style={{ color: '#333', marginTop: '10px', fontSize: '14px', lineHeight: '1.5' }}>
                                    {this.state.errorMessage}
                                </p>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                <button 
                                    style={{
                                        padding: '8px 25px', cursor: 'pointer', borderRadius: '3px',
                                        border: 'none', background: '#dc3545', color: 'white', fontWeight: 'bold'
                                    }} 
                                    onClick={() => this.setState({ showErrorModal: false })}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    };
}

export default BarChartwRefLine;